import MuiLinearProgress from '@mui/material/LinearProgress';

export interface LinearProgressProps {
  // 0–100, clamped. Callers derive the percentage from two independent reads, so a raced
  // pair can arithmetically exceed the range and MUI would paint past its own track.
  value: number;
  // Required, not optional: MUI gives role and value for free, but a bar whose only
  // visible label is the number beside it has no accessible name.
  'aria-label': string;
}

const PILL_RADIUS = '9999px';

// Determinate meter behind the facade.
export function LinearProgress({ value, 'aria-label': ariaLabel }: LinearProgressProps) {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <MuiLinearProgress
      variant="determinate"
      value={clamped}
      aria-label={ariaLabel}
      sx={{
        height: 8,
        borderRadius: PILL_RADIUS,
        // MUI rounds neither the track nor the fill; both need it, or the fill ends
        // square inside a rounded track.
        '& .MuiLinearProgress-bar': { borderRadius: PILL_RADIUS },
      }}
    />
  );
}
